import tippy from "tippy.js";
import { Fancybox } from "@fancyapps/ui";
import MicroModal from "micromodal";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function init() {
  // if #wpadminbar add class to #js-header-nav
  console.log(jQuery("#wpadminbar").length > 0);

  if (jQuery("#wpadminbar").length > 0) {
    console.log("wpadminbar");

    jQuery("#js-header-nav").addClass("mt-8");
  }

  MicroModal.init();
  // MicroModal.show("modal-1");
  tippy("[data-tippy]", {
    placement: "bottom",
    onShow(instance) {
      instance.popper.hidden = instance.reference.dataset.tippy ? false : true;
      instance.setContent(instance.reference.dataset.tippy);
    },
  });

  jQuery("#js-menu-open, #js-menu-close, #js-menu-overlay").on(
    "click",
    function () {
      jQuery("#js-menu-overlay").toggleClass("invisible");
      jQuery("#js-menu-overlay").toggleClass("bg-opacity-70");
      jQuery("#js-menu-overlay").toggleClass("opacity-0");
      jQuery("#js-menu").toggleClass("-left-full");
      jQuery("#js-menu").toggleClass("left-0");
      jQuery("body").toggleClass("overflow-hidden");
    }
  );

  // #js-header-nav stiky when scroll down
  const headerNav = jQuery("#js-header-nav");
  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      headerNav.addClass("bg-white");
      headerNav.addClass("shadow-lg");
      headerNav.addClass("text-primary");
      headerNav.removeClass("text-white");
    } else {
      headerNav.removeClass("bg-white");
      headerNav.removeClass("shadow-lg");
      headerNav.removeClass("text-primary");
      headerNav.addClass("text-white");
    }
  });

  // Init Galerie
  Fancybox.bind("[data-fancybox='galerie']", {
    // Your options go here
    thumbs: {
      autoStart: true,
    },
  });
}
